import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

import "./Store.css";

export default function Staff() {
  const [show, setShow] = useState(false);
  const [fullscreen, setFullscreen] = useState(true);
  const [storeList, setStoreList] = useState([]);
  const [gridApi, setGridApi] = useState("");
  const gridRef = useRef();

  const handleShow = () => {
    setShow(true);
    setFullscreen(true);
  };

  const token = localStorage.getItem("token");
  // Trans Table - start\

  const columnDefs = [
    {
      headerName: "Store Name",
      field: "name",
      width: 300,
    },
    {
      headerName: "Store Name in Arabic",
      field: "nameAr",
      width: 300,
    },
    {
      headerName: "Store Address",
      field: "address",
      width: 350,
    },
    {
      headerName: "Store Address in Arabic",
      field: "addressAr",
      width: 350,
    },
  ];

  const defaultColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
  };

  const onGridReady = useCallback((params) => {
    params.api.sizeColumnsToFit();
    setGridApi(params);
    axios
      .post(
        "https://hook.eu1.make.com/uyi4pn2prj0yf5yawjv7nivw8vm253sj",
        { token },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if(res.data.statusCode === 401){
          Cookies.remove("phone_number");
          Cookies.remove("national_id");
          localStorage.clear();
          window.location.reload();
        }
        else{
          params.api.applyTransaction({ add: res.data.data.stores.rows });
        }
      });
  }, []);

  const onExportClick = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  // Trans Table - end

  const { t } = useTranslation();

  return (
    <div className="staff d-grid">
      <Button
        variant="light"
        type="submit"
        className="account-btn py-3"
        size="lg"
        onClick={handleShow}
      >
        {t("viewStores")}
      </Button>
      <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t("viewStores")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="filter-parent py-1 mb-2">
            <Button variant="warning" size="sm" className="px-4 my-2 mx-2">
              <NavLink to="/addStore" className="add-user-btn">
                {t("addnewstore")}
              </NavLink>
            </Button>
            <Button
              variant="success"
              size="sm"
              className="px-4 my-2 mx-2"
              onClick={onExportClick}
            >
              Export to Excel
            </Button>
          </div>
          <div className="ag-theme-alpine trans-table">
            <AgGridReact
              ref={gridRef}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
